<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="icon-list-list" v-if="fields?.list?.length > 0">
        <siteLink
          class="icon-list-list-item"
          v-for="item in fields?.list"
          :key="item"
          :link="getContactLink(item?.fields)"
          @click="onItemClick($event, item?.fields)"
        >
          <div class="icon-list-list-item-icon">
            <Icon :svg="item?.fields?.icon?.value?.svgCode" />
          </div>
          <div class="icon-list-list-item-content">
            <JssRichText class="icon-list-list-item-title" :field="item?.fields?.title" />
            <JssRichText class="icon-list-list-item-desc" :field="item?.fields?.desc" />
          </div>
        </siteLink>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'IconList',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'icon-list'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const getContactLink = (itemFields) => {
      const link = itemFields?.link;
      if (!link) return link;
      const contactId = itemFields?.contactId?.value;
      const href = link?.value?.href;
      if (!contactId || !href) return link;
      return {
        ...link,
        value: {
          ...link.value,
          href: href.includes('#') ? href : `${href}#${contactId}`,
        },
      };
    };

    const onItemClick = (e, itemFields) => {
      const contactId = itemFields?.contactId?.value;
      if (!contactId) return;
      const href = itemFields?.link?.value?.href;
      if (href) return;
      e.preventDefault();
      e.stopPropagation();
      const anchor = document.getElementById(contactId);
      if (anchor) {
        const offset = anchor.getBoundingClientRect();
        window.scrollTo(0, window.scrollY + offset.top - 80);
      }
    };

    return {
      rootClass,
      rootStyle,
      getContactLink,
      onItemClick,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.icon-list {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &-item {
      display: flex;
      align-items: center;
      gap: 12px;

      &-icon {
        width: 40px;
        height: 40px;
        border: 1px solid $blue-night;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-title {
        font-size: 24px;
        line-height: 30px;
        font-weight: 600;
        color: $black;
      }

      &-desc {
        font-size: 16px;
        line-height: 1.4;
        color: $black;
        margin-top: 8px;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;

      &-item {
        width: 33%;

        &-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>
